import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CloseCreditAccountRequest, closeCreditAccount } from '@/react-query/services/account';

export const useCloseCreditAccount = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['closeCreditAccount'],
        mutationFn: ({ accountToClose, accountToReceive, reason }: CloseCreditAccountRequest) =>
            closeCreditAccount({ accountToClose, reason, accountToReceive }),
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['myCreditCards'] });
        },
    });
};
